/**
 * L'en-tête de « Travail entre les lives » : Sam et ce qu'il propose, dans sa bulle — la même que
 * dans « Préparer mon live » (`<ChampionSays>`) —, puis « Pour qui ? ». Le legacy l'a resserré à côté de
 * Sam pour que la première carte reste au-dessus du pli, sur un écran que le masteur enchaîne après
 * chaque live. Rien ne dépend d'une donnée : la page et son squelette le posent tous deux.
 */
import React from "react"

import { Stack } from "../../atoms/containers/Stack"
import { SectionLabel } from "../../atoms/typography/SectionLabel"
import { Text } from "../../atoms/typography/Text"
import { Title } from "../../atoms/typography/Title"
import { ChampionSays } from "../../molecules/ChampionSays"

export function TutorPrescriptionIntro(props: { withAudience?: boolean }) {
    const { withAudience = true } = props
    return (
        <Stack gap="5">
            <ChampionSays
                message={
                    <Stack gap="1">
                        <Title>Travail entre les lives</Title>
                        <Text size="text-sm" color="text-muted">
                            Je te propose un travail personnalisé pour chaque élève.
                        </Text>
                    </Stack>
                }
            />
            {withAudience && <SectionLabel>Pour qui ?</SectionLabel>}
        </Stack>
    )
}
